<mbs-modal
  #modal
  [isCustomModal]="true"
  [showFooter]="true"
  [title]="'shared:licenses.management.buyLicense' | i18next"
  [titleTextOverflow]="true">
  <div modal-body>
    {{ 'shared:licenses.management.youWillRedirectedToLicensesPage' | i18next }}
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      (click)="proceed()">
      {{ 'shared:buttons.proceed' | i18next }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()"
      >{{ 'shared:buttons.close' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
